import styled from 'styled-components';
var IconContainerRounded = /*#__PURE__*/styled.div.withConfig({
  displayName: "icon-container-rounded__IconContainerRounded",
  componentId: "sc-1fcy5yz-0"
})(["display:flex;justify-content:center;align-items:center;width:40px;height:40px;border-radius:50%;background-color:", ";margin-right:16px !important;"], function (props) {
  return props.accent;
});
export default IconContainerRounded;